import AppLogoIcon from "./app-logo-icon"

interface AppLogoProps {
  variant?: "default" | "wordmark"
}

export default function AppLogo({ variant = "default" }: AppLogoProps) {
  if (variant === "wordmark") {
    return (
      <span
        style={{
          fontFamily: "'Figtree', sans-serif",
          fontWeight: 800,
          fontSize: 20,
          letterSpacing: "-0.02em",
          color: "var(--fig-text-primary)",
        }}
      >
        fig
      </span>
    )
  }

  return (
    <>
      <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-md">
        <AppLogoIcon className="size-5 fill-current text-white" />
      </div>
      <div className="ml-1 grid flex-1 text-left text-sm">
        <span className="mb-0.5 truncate leading-tight font-semibold">
          {import.meta.env.VITE_APP_NAME ?? "Fig"}
        </span>
      </div>
    </>
  )
}
